<template>
  <div v-if="show" class="animated fadeIn" ref="container">
    <vs-table ref="table" :params="params" :options="options"></vs-table>
  </div>
</template>

<script>
import VsTable from "../_framework/VsTable.vue";
import EventBus from "../_framework/bus.js";
import Vue from "vue";
import OpenAccountingDocumentButton from "../components/OpenAccountingDocumentButton.vue";
import CreatorInput from "../components/CreatorInput.vue";
import BaseService from "../_framework/api/BaseService.js";

export default {
  name: "accounting-documents-list",
  components: {
    VsTable,
    CreatorInput
  },
  mounted() {
    EventBus.$on("onReloadPageContent", () => {
      // reload current page
      this.show = !this.show;
      setTimeout(() => {
        this.show = !this.show;
      }, 100);
    });
  },
  beforeMount() {
    this.options.access = checkAccess(this.$route.path);
    //console.log(this.options.access);
    this.show = this.options.access ? true : false;
  },
  data() {
    return {
      access: {},
      show: true,
      params: {
        entity: "AccountingVouchers",
        list: [],
        headers: {
          // journals: {
          //   title: "شماره سند",
          //   type: "text",
          //   rowAlignment: "center"
          // },
          rowCount: {
            title: "تعداد ردیف",
            type: "number",
            rowAlignment: "center"
          },
          date: {
            title: "تاریخ",
            type: "text",
            rowAlignment: "center",
            formatGregorianDateToJalaali: true
          },
          remain: {
            title: "جمع گردش",
            type: "number",
            rowAlignment: "center"
          },
          createdBy: {
            title: "صادر کننده",
            type: "custom",
            component: CreatorInput,
            rowAlignment: "center"
          },
          description: {
            title: "شرح سند",
            type: "text",
            rowAlignment: "center"
          },
          attachment: {
            title: "پیوست",
            type: "number",
            rowAlignment: "center"
          }
        }
      },
      options: {
        hasActions: true,
        hasActionsInHeader: false,
        clickableRows: true,
        getTopRightButtons: () => {
          let arr = [];
          let addItemButton = {
            component: "open-accounting-document-button",
            params: {
              mode: "create"
            }
          };
          arr.push(addItemButton);
          return arr;
        },
        getTopLeftButtons: () => {
          let arr = [];
          let self = this;
          let addItemButton = {
            component: "toggle-table-actions-button",
            params: {
              onClick() {
                self.options.hasActions = !self.options.hasActions;
              }
            }
          };
          arr.push(addItemButton);
          return arr;
        },
        onRowDoubleClicked: row => {
          this.getAccountDocumentById(row.id, "view");
        },
        onEditClicked: (row, context) => {
          this.getAccountDocumentById(row.id, "edit");
        }
      }
    };
  },
  methods: {
    getAccountDocumentById(id, _mode) {
        this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
        this.$router.push({
          path: "accounting-documents",
          query: { id, _mode }
        });
    }
  }
};
</script>